import React, { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Icon from "../Icon";
import DropDown from "./DropDown";
import styles from "./Menu.module.scss";

const Menu = ({ children, options, onSelect, className, iconName }) => {
  const [referenceElement, setReferenceElement] = useState(null);

  return (
    <>
      <span tabIndex={-1} ref={setReferenceElement} className={cx(styles.wrap, className)}>
        <Icon size={22} className={styles.menuIcon} icon={iconName} />
      </span>
      {referenceElement && (
        <DropDown referenceElement={referenceElement} options={options} onSelect={onSelect}>
          {children}
        </DropDown>
      )}
    </>
  );
};

Menu.MenuItem = DropDown.Item;

Menu.defaultProps = {
  className: undefined,
  options: undefined,
  children: undefined,
  iconName: "dots-three-vertical"
};

Menu.propTypes = {
  children: PropTypes.node,
  /** If pass onClick to options it will overwrite default onSelect */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired
    }).isRequired
  ),
  onSelect: PropTypes.func.isRequired,
  className: PropTypes.string,
  /** Change menu icon */
  iconName: PropTypes.string
};

export default Menu;
